const Indigo = {
    title: 'Indigo',
    background: 'radial-gradient(circle, #ab85d6 0%, #8942db 100%)',
    colors: {
        primary: '#8942db',
        secondary: '#9760d6',
        terciary: '#ab85d6',
        fourth: '#e3d7fa',
        fifth: '#f6f2fc'
    }
};

export default Indigo;